/*
 * @Author: your name
 * @Date: 2020-09-02 11:17:07
 * @LastEditTime: 2020-09-02 11:20:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /dmps-console-web/src/store/module/publisher.js
 */
import * as types from '../mutation-types'

const user = {
  state: {
    publisherId: '',
    publisherInfo: {},
    journalList: [],
    journalId: '',
    personalJournalList: []
  },

  getters: {
    getPublisherId: state => state.publisherId,
    getPublisherInfo: state => state.publisherInfo,
    getJournalList: state => state.journalList,
    getJournalId: state => state.journalId,
    getPersonalJournalList: state => state.personalJournalList
  },

  actions: {
    updatePublisherId({ commit }, info) {
      commit(types.UPDATE_PUBLISHER_ID, info)
    },
    updatePublisherInfo({ commit }, info) {
      commit(types.UPDATE_PUBLISHER_INFO, info)
    },
    updateJournalList({ commit }, info) {
      commit(types.UPDATE_JOURNAL_LIST, info)
    },
    updateJournalId({ commit }, info) {
      commit(types.UPDATE_JOURNAL_ID, info)
    },
    updatePersonalJournalList({ commit }, info) {
      commit(types.UPDATE_PERSONAL_JOURNAL_LIST, info)
    }
  },

  mutations: {
    [types.UPDATE_PUBLISHER_ID](state, info) {
      state.publisherId = info
    },
    [types.UPDATE_PUBLISHER_INFO](state, info) {
      state.publisherInfo = info
    },
    [types.UPDATE_JOURNAL_LIST](state, info) {
      state.journalList = info
    },
    [types.UPDATE_JOURNAL_ID](state, info) {
      state.journalId = info
    },
    [types.UPDATE_PERSONAL_JOURNAL_LIST](state, info) {
      state.personalJournalList = info
    }
  }
}

export default user
